<template>
    <div class="movementDataRow" v-if="country">
            <span class="currentRiskScore" :style="'color:' + country.riskCategoryObject.color + '; '">{{this.country.riskData[0].star}}</span>
            <span class="movementDirectionArrow">
                <v-icon class="arrow-icon" v-if="country.riskData[0].difference < 0">mdi-arrow-up</v-icon>
                <v-icon class="arrow-icon" v-if="country.riskData[0].difference > 0">mdi-arrow-down</v-icon>
            </span>
            <span class="movementDifference" v-if="country.riskData[0].difference !== 0" :style="'color:' + getHexColor(country.riskData[0].star_previous_quarter)">{{ country.riskData[0].star_previous_quarter }}</span>
    </div>
</template>

<script>
import {
    Service as CountryService
} from '@/services/countryService';

import {
    riskToNumeric,
    getRiskCategory,
    riskMapColours
} from '@/services/dataHandlerService';

export default {
    name: 'MovementWidget',
    props: {
        countryObject: Object,
    },
    data() {
        return {            
            country: null,
        };
    },
    methods: {
        getHexColor(risk) {
            const numericRisk = riskToNumeric(risk);
            const riskCategory = getRiskCategory(numericRisk);
            const hexColor = riskMapColours[riskCategory - 1];            
            return hexColor.color;
        },
    },
    mounted() {
        if (this.countryObject) {
            this.country = this.countryObject;
        }

        //Deal with changes to movement data

        // if(!this.country.riskData[0].difference){
        //     this.country = CountryService.getCountryKeyData(this.country.countryObject);
        // }

        
    },
    // methods: {
    //     getMovementDirection() {
    //       return CountryService.getMovementDirection(this.country);
    //     },
    //     getMovementValue() {
    //         return CountryService.getMovementValue(this.country);
    //     },
    //     getMovementDifference() {
    //         return CountryService.getMovementDifference(this.country);
    //     },
    //     getRiskCat() {
    //         return CountryService.getRiskCat(this.country);
    //     },
    //     getStarCategory() {
    //         console.log('getStarCat', this.country);
    //         return CountryService.getStarCat(this.country);
    //     },

    // },
}
</script>

<style scoped>
    *{
        font-family: "GCO" !important;
    }
    .currentRiskScore{
        font-size: 20px;
        position: relative;
        top: -2px;
    }
</style>
